import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Input, Row, Select, Typography } from "antd";
import { Icon } from "assets/icons";
import CustomTable from "components/CustomTable";
import RadioGroup from "features/Warranty/WarrantyList/component/RadioGroup";
import { t } from "i18next";
import { SEARCH_TYPE } from "pages/App/Product/constants";
import CategoryTreeFilter from "../CategoryTreeFilter";
import TagsList from "../TagsList";

const { Option } = Select;

function ModalSelectProductBody({
  columns,
  lockCategoryFilter = false,
  isUpdate,
  filterItemsTypeOptions,
  rowSelection,
  selectionType = "checkbox",
  loadingCheckDuplicateCodes,
  loadingProduct,
  dataSource,
  onTableChange,
  paginationData,
  isFilterSelected,
  selectedRows,
  dataDuplicateCode,
  filterProductByCategoryId,
  params,
  handleSearch,
  searchType,
  handleSelectSearchType,
  itemsSearchBulk,
  handleChangeSelectSearch,
  handleChange,
  dataManufactures,
  loadingManufactures,
  listWarehouse,
  loadingWarehouses,
  prodAtt,
  setParams,
}) {
  return (
    <>
      <Row
        gutter={[16, 4]}
        style={{
          alignItems: "center",
          borderRadius: "8px",
          margin: 0,
        }}
      >
        <Col span={24}>
          <Row gutter={[16]} style={{ alignItems: "flex-end" }}>
            <Col span={6}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <Typography.Text style={{ marginBottom: "4px" }} strong>
                  {t("product.productForm.category")}
                </Typography.Text>
                <div>
                  {lockCategoryFilter ? (
                    <CategoryTreeFilter onFilter={() => undefined} defaultValue={params.filters.categoryIDs} disabled />
                  ) : (
                    <CategoryTreeFilter
                      onFilter={filterProductByCategoryId}
                      defaultValue={params.filters.categoryIDs}
                    />
                  )}
                </div>
              </div>
            </Col>
            <Col span={10}>
              <div style={{ height: "32px", display: "flex", alignItems: "center" }}>
                <Typography.Text strong>{t("campaign.combo.searchAdvance")}</Typography.Text>
              </div>
              <div className="custom-search-product-wrapper">
                <Input.Group compact>
                  <Select
                    onChange={handleSelectSearchType}
                    defaultValue={searchType}
                    value={searchType}
                    className="select-search-type"
                  >
                    <Option value={SEARCH_TYPE.SINGLE}>Tìm kiếm từng mã sản phẩm</Option>
                    <Option value={SEARCH_TYPE.BULK}>Tìm kiếm hàng loạt</Option>
                  </Select>
                  {searchType === SEARCH_TYPE.SINGLE ? (
                    <Input
                      prefix={<FontAwesomeIcon icon={Icon.faSearch} />}
                      placeholder={t("product.searchPlaceholder")}
                      onChange={handleSearch}
                      allowClear
                      defaultValue={params.filters.query}
                      style={{ width: "350px" }}
                    />
                  ) : (
                    <Select
                      mode="tags"
                      value={itemsSearchBulk}
                      onChange={handleChangeSelectSearch}
                      placeholder="Tìm kiếm các mã sản phẩm được ngăn cách với nhau bằng dấu phẩy/ đấu cách"
                      className="custom-select-search-product"
                      open={false}
                      dropdownStyle={{ display: "none" }}
                    />
                  )}
                </Input.Group>
              </div>
            </Col>
            <Col span={8} style={{ paddingTop: "30px" }}>
              <RadioGroup
                filterItemsTypeOptions={filterItemsTypeOptions}
                handleChange={handleChange}
                isUpdate={isUpdate}
              />
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <TagsList
            listFilter={params.filters}
            dataManufactures={dataManufactures}
            loadingManufactures={loadingManufactures}
            dataWarehouses={listWarehouse}
            loadingWarehouses={loadingWarehouses}
            dataAttributes={prodAtt}
            params={params}
            setParams={setParams}
          />
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <CustomTable
            rowSelection={{
              type: selectionType,
              ...rowSelection,
            }}
            columns={columns}
            loading={loadingCheckDuplicateCodes || loadingProduct}
            dataSource={dataSource}
            rowKey={(record) => record?.id}
            onChange={onTableChange}
            pagination={{
              total: isFilterSelected ? selectedRows?.length : paginationData?.total,
              pageSize: paginationData?.limit,
              current: paginationData?.offset / paginationData?.limit + 1 || 1,
              showSizeChanger: false,
            }}
            scroll={{ x: "max-content" }}
          />
        </Col>
        <Col span={24}>
          {dataDuplicateCode?.length ? (
            <Typography>
              <Typography.Paragraph type="danger">
                {t("campaign.combo.errorDuplicateCodes", {
                  productLength: dataDuplicateCode?.length,
                })}
                :{" "}
                <Typography.Text type="danger" strong>
                  {dataDuplicateCode?.map((item) => item).join(", ")}
                </Typography.Text>
              </Typography.Paragraph>
              <Typography.Paragraph type="danger">
                {t("campaign.combo.errorDuplicateCodesWarning")}
              </Typography.Paragraph>
            </Typography>
          ) : null}
        </Col>
      </Row>
    </>
  );
}

export default ModalSelectProductBody;
